import React from "react";
import { URLImgFront } from '../../../../config/URLDB';
import ReCAPTCHA from "react-google-recaptcha";
import Swal from 'sweetalert2';
import { ConsultarDatosClienteCampania, ListTiposIdentificacion_ } from '../../../../services/WebAPI_Utrahuilca';
import ConsultaRepresentante from "./FormRepresentanteLegal";
import Loading from '../../../Loading';

class Consulta extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            tipoiden: 'DEFAULT',
            nit: '',
            fecexpe: '',
            errors: {},
            nombre: '',
            estado: false,
            estadoLoading: false,
            tiposid: [],

            //VARIABLE PARA EL CAPTCHA
            consulta: true,
        };

        this.recaptchaRef = React.createRef();
    }

    async componentDidMount() {
        await this.CargarTipoIdentificacion();
    }

    CargarTipoIdentificacion = async () => {
        const datos = { tran: 8, idtipodoc: 0, abreviatura: 'N/A', desctipodoc: 'N/A', abrevutraweb: 'N/A', idtipopers: 0, estado: 1 };
        try {
            const registros = await ListTiposIdentificacion_(datos);
            const cantregistros = registros?.length ?? 0;
            const sinresultados = registros[0]?.message === '004404';
            if (cantregistros > 0 && !sinresultados) {
                let tiposid = [];
                for (const tipoid of registros) {
                    tiposid.push({ value: tipoid.idtipodoc, label: tipoid.desctipodoc, abrevutraweb: tipoid.abrevutraweb });
                }
                this.setState({
                    tiposid
                });
            }
        }
        catch {
            this.MostrarModal('Ocurrio un error!');
        }
    }

    validarCampos = (valores) => {
        const errors = {}
        if (valores.tipoiden === 'DEFAULT') {
            errors.tipoiden = 'campo obligatorio'
        }
        if (!valores.nit) {
            errors.nit = 'campo obligatorio'
        }
        if (!valores.fecexpe) {
            errors.fecexpe = 'campo obligatorio'
        }
        return errors;
    };

    asignarValor = (e) => {
        let { name, value } = e.target;

        //NO PERMITE SÍMBOLOS 
        if (name === 'nit') {
            if (this.state.tipoiden === 'PAS') {
                value = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
            } else { //NI LETRAS
                value = value.replace(/[^0-9]/g, '');
            }
        }

        if (name === "fecexpe") {
            //SE TOMA EXACTAMENTE EL AÑO
            const yearPart = value.split("-")[0];
            if (yearPart.length > 4) {
                this.setState({ [yearPart]: "" }); return;
            }
        }

        this.setState({ [name]: value });
    };

    ConsultarDatos = () => {
        const { errors, ...sinErrors } = this.state;
        const resultado = this.validarCampos(sinErrors);
        this.setState({ errors: resultado });

        //SE VALIDA SI HAY CAMPOS INCOMPLETOS
        if (Object.keys(resultado).length > 0) {
            if (this.recaptchaRef.current) {
                this.recaptchaRef.current.reset();
            }
            return;
        }

        if (!Object.keys(resultado).length) {
            this.setState({
                estadoLoading: true
            });

            const data = {
                tran: 12,
                tipoiden: this.state.tipoiden,
                nit: this.state.nit,
                fec_exp: this.state.fecexpe,
                id_camp: 36
            }

            ConsultarDatosClienteCampania(data).then(response => {
                try {
                    if (response.data.length > 0) {
                        if (response.data[0].codresp) {

                            if (this.recaptchaRef.current) {
                                this.recaptchaRef.current.reset();
                            }

                            Swal.fire({
                                icon: 'error',
                                title: response.data[0].desresp
                            })
                        }
                        else {
                            this.setState({
                                nombre: response.data[0].nomcom,
                                puntos: response.data[0].puntos,
                            });
                            this.props.asignarDatosBasicos(response.data[0]?.nivelaso, response.data[0]?.id_cliente, response.data[0]?.puntos, response.data[0]?.nomcom, response.data[0]?.nit, response.data[0]?.correo, response.data[0]?.telcel, response.data[0]?.tipoiden);
                            if (response.data[0].repreinfan === 1) {
                                this.setState({ mostrarRepresentante: true });
                                Swal.fire({
                                    icon: 'warning',
                                    title: 'Para continuar con la redención, registra los datos del Representante Legal aquí.'
                                })
                            } else {
                                this.setState({ estado: true });
                                this.props.mostrarConsulta(true, 2)
                            }
                        }
                    } else {
                        Swal.fire({
                            icon: 'warning',
                            title: 'No se encontró información de la consulta'
                        })
                    }
                }
                catch (error) {
                    this.setState({
                        tipoiden: 'DEFAULT',
                        nit: '',
                        fecexpe: '',
                        errors: {},
                        nombre: '',
                        puntos: 0,
                        estado: false
                    });

                    if (this.recaptchaRef.current) {
                        this.recaptchaRef.current.reset();
                    }

                    Swal.fire({
                        icon: 'error',
                        title: 'Novedad en la consulta de puntos'
                    })
                }

                this.setState({
                    estadoLoading: false
                });
            });
        }
    }

    mostrarPuntos = (mostrar) => {
        this.setState({ estado: mostrar, mostrarRepresentante: !mostrar });
    }

    render() {
        const { tipoiden, nit, fecexpe, errors } = this.state;
        return (
            <div className="aos-button-wrapper d-flex justify-content-center" data-aos="fade-right" >
                <div className="d-flex justify-content-center flex-column align-items-center " style={{ gap: "20px" }}>
                    {!this.state.estado ? (
                        <>
                            <p className="text-white" style={{ fontSize: 'clamp(25px, 4vw, 60px)' }}>Consulta y <span className="d-inline font-weight-bold font-italic">redime tus puntos</span></p>
                            <div className="text-center">
                                <h5 className="text-white font-weight-bold mb-1">Tipo de documento</h5>
                                <select name="tipoiden" className="d-block coopenautas-control-consulta" value={tipoiden} onChange={this.asignarValor}>
                                    <option value="DEFAULT" disabled>Selecciona...</option>
                                    {this.state.tiposid.map((e, i) => {
                                        return [
                                            <option key={i} value={e.abrevutraweb}>{e.label}</option>
                                        ]
                                    })}
                                </select>
                                {errors.tipoiden && <strong className="text-danger small">{errors.tipoiden}</strong>}
                            </div>
                            <div className="text-center">
                                <h5 className="text-white font-weight-bold mb-1">Número de documento</h5>
                                <input name="nit" type="text" className="d-block coopenautas-control-consulta" value={nit} maxLength="20" onChange={this.asignarValor} />
                                {errors.nit && <strong className="text-danger small">{errors.nit}</strong>}
                            </div>
                            <div className="text-center">
                                <h5 className="text-white font-weight-bold mb-1">Fecha expedición</h5>
                                <input name="fecexpe" type="date" className="d-block coopenautas-control-consulta" value={fecexpe} onChange={this.asignarValor} />
                                {errors.fecexpe && <strong className="text-danger small">{errors.fecexpe}</strong>}
                            </div>
                            <div className="d-flex justify-content-center">
                                <ReCAPTCHA ref={this.recaptchaRef} sitekey="6LfTTPgbAAAAAOKQp-b36jm-sJGpLIKw8cnZTzu-" onChange={() => this.setState({ consulta: !this.recaptchaRef.current.getValue() })} />
                            </div>
                            <div className="d-flex flex-column flex-md-row align-items-center" style={{ gap: "10px", maxWidth:'100%' }}>
                                <button id="BtnRegresar" className="coopenautas-btn" style={{ backgroundImage: `url(${URLImgFront}/assets/EstrategiasComerciales/Coopenautas/BtnRegresar.svg)`, width: 'clamp(100px, 40vw, 200px)', aspectRatio: '200/ 50' }} onClick={() => this.props.mostrarConsulta(false, 1)} />
                                <button id="BtnConsultar" className="coopenautas-btn" style={{ backgroundImage: `url(${URLImgFront}/assets/EstrategiasComerciales/Coopenautas/BtnConsultar.svg)`, width: 'clamp(100px, 40vw, 200px)', aspectRatio: '200/ 50' }} disabled={this.state.consulta} onClick={this.ConsultarDatos} />
                            </div>
                        </>
                    ) : (
                            <>
                                <div className="row">
                                    <div className="col-12 datos-consulta px-2">
                                        <div className="px-4">
                                            <span className="text-white" style={{ fontSize: 'clamp(28px, 4vw, 40px)', fontWeight: 'bold', textTransform: 'capitalize' }}> {this.state.nombre} </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row pt-2">
                                    <div className="col-12 d-flex align-items-center">
                                        <div className="flex-fill">
                                            <input type="text" value={this.state.puntos + " PUNTOS"} disabled className="text-center" style={{ border: '2px solid #009A00', fontSize: '3.3vmin', maxWidth: '325px', borderRadius: '30px', color: '#ffffff', backgroundColor: '#009A00', fontWeight: '900' }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex" style={{ gap: "10px", maxWidth: '100%' }}>
                                    <button id="BtnRegresar" className="coopenautas-btn" style={{ backgroundImage: `url(${URLImgFront}/assets/EstrategiasComerciales/Coopenautas/BtnRegresar.svg)`, width: 'clamp(100px, 40vw, 200px)', aspectRatio: '200/ 50' }} onClick={() => this.props.mostrarConsulta(false, 1)} />
                                    <button id="BtnRegresar" className="coopenautas-btn" style={{ backgroundImage: `url(${URLImgFront}/assets/EstrategiasComerciales/Coopenautas/BtnRedimir.svg)`, width: 'clamp(100px, 40vw, 200px)' }} onClick={() => this.props.navegarSeccion(5)} />
                                </div>
                        </>
                    )}

                    {this.state.estadoLoading && (
                        <div style={{ maxWidth: '1000px', maxHeight: '580px', height: '580px', width: '1000px', overflow: 'hidden', zIndex: 99999999, position: 'absolute' }}>
                            <div style={{ transform: 'scale(0.8)', transformOrigin: 'top left', width: '125%', height: '125%' }}>
                                <Loading alto={'100%'} />
                            </div>
                        </div>
                    )}
                </div>

                {this.state.mostrarRepresentante && (
                    <div style={{ position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', zIndex: '1050', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '1rem' }} data-aos="zoom-in" onClick={() => this.setState({ mostrarRepresentante: false })}>
                        <div style={{ maxWidth: '1000px', maxHeight: '580px', backgroundColor: "#ffff", padding: '1.5rem', borderRadius: '12px', boxShadow: '0 0 30px rgba(0, 0, 0, 0.5)', height: '580px', width: '1000px' }} onClick={(e) => e.stopPropagation()}>
                            <ConsultaRepresentante mostrarConsulta={this.props.mostrarConsulta} mostrarPuntos={this.mostrarPuntos} nit={this.state.nit} tipoiden={this.state.tipoiden} asignarDatosBasicos={this.props.asignarDatosBasicos} />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default Consulta;